<form
    class="flex flex-col p-4"
    [formGroup]="form">
    <mat-form-field>
        <mat-label>Name</mat-label>
        <input
            matInput
            formControlName="name" />
    </mat-form-field>
    <div class="flex gap-x-4">
        <mat-form-field>
            <mat-label>Start date</mat-label>
            <input
                matInput
                [matDatepicker]="startDatePicker"
                formControlName="startDate" />
            <mat-datepicker-toggle
                matIconPrefix
                [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Hours</mat-label>
            <input
                type="number"
                noScroll
                matInput
                formControlName="startDateHours" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Minutes</mat-label>
            <input
                type="number"
                noScroll
                matInput
                formControlName="startDateMinutes" />
        </mat-form-field>
    </div>
    <div class="flex gap-x-4">
        <mat-form-field>
            <mat-label>End date</mat-label>
            <input
                matInput
                [matDatepicker]="endDatePicker"
                formControlName="endDate" />
            <mat-datepicker-toggle
                matIconPrefix
                [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Hours</mat-label>
            <input
                type="number"
                noScroll
                matInput
                formControlName="endDateHours" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Minutes</mat-label>
            <input
                type="number"
                noScroll
                matInput
                formControlName="endDateMinutes" />
        </mat-form-field>
    </div>
    <mat-form-field>
        <mat-label>Ignore users with install for</mat-label>
        <mat-select
            multiple
            formControlName="installedOffersIgnoreList">
            @for (offer of offersStore.offers(); track offer) {
                <mat-option [value]="offer.id">
                    {{ offer.affiseOfferId }} {{ offer.title }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-checkbox
        class="mb-5"
        color="primary"
        formControlName="isActive">
        Active
    </mat-checkbox>
    <div formArrayName="groups">
        <h1 class="mb-5 text-xl font-medium">Groups</h1>
        <button
            type="button"
            class="mb-5"
            mat-flat-button
            color="primary"
            (click)="addGroup()">
            Add group
        </button>
        @for (group of form.value.groups; track $index) {
            <div
                class="mb-5 flex flex-col rounded-lg border border-black p-5"
                [formGroupName]="$index">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input
                        matInput
                        formControlName="name" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Target users percentage</mat-label>
                    <input
                        type="number"
                        noScroll
                        matInput
                        formControlName="targetUsersPercentage" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Users count</mat-label>
                    <input
                        type="number"
                        noScroll
                        matInput
                        formControlName="usersCount" />
                </mat-form-field>
            </div>
        }
    </div>
    <button
        class="self-start"
        type="button"
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="createOrUpdateTest()">
        Save changes
    </button>
</form>
